export function isValidBirthday(birthdayDate: string): boolean {
  if (!birthdayDate || birthdayDate.length === 0) return true;
  const [year, month, day] = birthdayDate.split('-');
  const daysInMonth = (month, year): number => new Date(year, month, 0).getDate();


  if (day && daysInMonth(month, year) < Number(day)) { return false; }
  else if (!day || !month || !year) { return false; }
  else if (!parseInt(day) || !parseInt(month) || !parseInt(year)) { return false; }
  else if (day.length < 1 || month.length < 1 || year.length < 4) { return false; }
  else if (new Date() < new Date(Number(year), Number(month), Number(day))) { return false; }
  else { return true }
}